module.exports = __webpack_public_path__ + "static/media/zw.ad4ad36d.svg";